/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Subscription_NoInputs */

const en_settings_billing_subscription_no = /** @type {(inputs: Settings_Billing_Subscription_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No.`)
};

/**
* | output |
* | --- |
* | "No." |
*
* @param {Settings_Billing_Subscription_NoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_subscription_no = /** @type {((inputs?: Settings_Billing_Subscription_NoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Subscription_NoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_subscription_no(inputs)
});
export { settings_billing_subscription_no as "settings.billing.subscription_no" }